export default "__VITE_ASSET__DBx3tqE7__"